import { render, staticRenderFns } from "./prizeredpacket.vue?vue&type=template&id=7a62179e&scoped=true"
import script from "./prizeredpacket.vue?vue&type=script&lang=js"
export * from "./prizeredpacket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a62179e",
  null
  
)

export default component.exports